import { useState } from 'react';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { MainMenuItemBlock } from './ItemBlock';

const TEN_YEARS = 10 * 365 * 24 * 60 * 60;

export function SwitchToNewApp() {
    const [switching, setSwitching] = useState(false);

    function switchToNewApp() {
        if (import.meta.env.DEV) {
            window.name = 'customer-app';
            window.open(parkingpayDevServerUrl(), 'parkingpay-app')?.focus();
            return;
        }
        document.cookie = `app-variant=parkingpay-app; Path=/; Max-Age=${TEN_YEARS}; Secure; SameSite=None`;
        setSwitching(true);

        // WKWebView hands document.cookie writes to its request store asynchronously,
        // a reload in the same tick can go out without the cookie.
        window.setTimeout(() => window.location.reload(), 500);
    }

    return (
        <MainMenuItemBlock
            onClick={switching ? null : switchToNewApp}
            title={
                <Localized
                    de="Zur neuen App wechseln"
                    fr="Passer à la nouvelle app"
                    it="Passa alla nuova app"
                    en="Switch to new app"
                />
            }
        />
    );
}

function parkingpayDevServerUrl(): string {
    const { protocol, hostname, port } = window.location;
    return port
        ? `${protocol}//${hostname}:8081/`
        : `${protocol}//${hostname.replace(/^customer\./, 'parkingpay.')}/`;
}
